__turbopack_context__.v({
  "dark": "styles-module-scss-module__lP9Vta__dark",
  "descriptionFavorite": "styles-module-scss-module__lP9Vta__descriptionFavorite",
  "headerImage": "styles-module-scss-module__lP9Vta__headerImage",
  "media-container": "styles-module-scss-module__lP9Vta__media-container",
});
